import {
  Component,
  Input,
  CUSTOM_ELEMENTS_SCHEMA,
  Output,
  EventEmitter,
} from '@angular/core';
import type { LeafPagination } from '@esi/leaf-web/lib/wc';

import '@esi/leaf-web/lib/wc/components/pagination/pagination';

@Component({
  selector: 'cigna-leaf-pagination',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-pagination
      [currentPage]="currentPage"
      [totalResults]="totalResults"
      [pageSize]="pageSize"
      [visiblePages]="visiblePages"
      [display]="display"
      [hideLastAndFirstButtons]="hideLastAndFirstButtons"
      (click)="pageChange.emit($event.currentTarget.currentPage)"
    ></leaf-pagination>
  `,
})
export class CignaLeafPaginationComponent {
  @Input() currentPage: LeafPagination['currentPage'];
  @Input() totalResults: LeafPagination['totalResults'];
  @Input() pageSize: LeafPagination['pageSize'];
  @Input() visiblePages: LeafPagination['visiblePages'];
  @Input() display: LeafPagination['display'];
  @Input() hideLastAndFirstButtons: LeafPagination['hideLastAndFirstButtons'];

  /**
   * ********
   * CUSTOM ANGULAR PROPERTIES
   */
  @Output() pageChange = new EventEmitter<number>();
}
